import React from "react";
import PageTitle from "../../components/PageTitle";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import moment from "../../helpers/moment";
import PayAcceptance from "./PayAcceptance";
import is_null from "../../helpers/is_null";
import VerifyPayment from "./VerifyPayment";
import PrintAcceptance from "./PrintAcceptance";

const Acceptance = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["acceptanceInformation"],
    queryFn: async () => {
      const req = await axiosget(`ms_applications/offered/admission`);
      return req?.data;
    },
  });
  const _remita_paid = (paid) => {
    if (is_null(paid)) {
      return `Remita RRR not generated`;
    }
    if (paid?.status === false) {
      return `Remita RRR ${paid?.RRR} Not Paid`;
    } else {
      return `RRR ${paid?.RRR} Paid`;
    }
  };

  const _status = (data) => {
    switch (data) {
      case 0:
        return "Pending";
      case 1:
        return "Provisional Admission";
      case 2:
        return "Conditional Admission";
      default:
        return "Invalid option";
    }
  };
  return (
    <div>
      <PageTitle title={`Admission Acceptance Fee`} sub={`Pay Acceptance Fee, Print Acceptance Letter, Print Acceptance Receipt`} />
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.type !== undefined && <ErrorResponse type={`danger`} message={data?.message} />}
      {!data?.length && (
        <ErrorResponse
          type={`info`}
          title={`NO APPROVED APPLICATIONS`}
          message={`Sorry, you have no applications that have been approved at the moment. Please check back later`}
        />
      )}
      {data &&
        data?.type === undefined &&
        data?.map((v, i) => {
          return (
            <div className="col-md-6 my-4" key={`_payments_for_letter_${i}`}>
              <div className="card border border-success">
                <div className="card-body">
                  <p className="card-text">
                    <b>Application Reference:</b> {v?.code}
                  </p>
                  <p className="card-text">
                    <b>Programme: </b>
                    {v?.programme?.code} :: {v?.programme?.name}
                  </p>
                  <p className="card-text">
                    <b>Admission Status:</b> {_status(v?.status)}
                  </p>
                  <p className="card-text">
                    <b>Acceptance Fee Status:</b> {_remita_paid(v?.acceptanceFee)}
                  </p>

                  <p className="card-text">
                    <b>Mode of Entry:</b> {v?.type}
                  </p>
                  <p className="card-text">
                    <b>Session: </b>
                    {v?.session?.code} :: {v?.session?.name}
                  </p>
                  <p className="card-text">
                    <b>Applied:</b> {moment(v?.createdAt)} ago
                  </p>
                </div>
                <div className="card-footer text-body-secondary text-right">
                  {v?.acceptanceFee === null ? (
                    <PayAcceptance v={v} />
                  ) : v?.acceptanceFee?.status === false ? (
                    <VerifyPayment v={v} />
                  ) : (
                    <PrintAcceptance v={v} />
                  )}
                  {/* <PrintSlip v={v} key={`print_slip_key_${i}`} /> */}
                </div>
              </div>
            </div>
          );
        })}
      {/* <MainAcceptance /> */}
    </div>
  );
};

export default Acceptance;
